// components/TourGuide.js
import Joyride from "react-joyride";

const TourGuide = ({ steps, runTour }) => {
  return (
    <Joyride
      steps={steps}
      run={runTour}
      continuous
      scrollToFirstStep
      showProgress
      showSkipButton
      disableOverlayClose={true}
      styles={{
        options: {
          primaryColor: "#4F46E5",
          textColor: "#1F2937",
          backgroundColor: "#FFFFFF",
          overlayColor: "rgba(0, 0, 0, 0.5)",
          spotlightPadding: 4, // Reduced from 8 to 4
          zIndex: 10000,
          arrowColor: "#FFFFFF",
        },
        tooltipContainer: {
          textAlign: "left",
        },
        tooltip: {
          borderRadius: "12px",
          padding: "20px 24px",
          boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.2)",
          border: "none",
          maxWidth: "400px",
        },
        tooltipTitle: {
          fontSize: "1.2rem",
          fontWeight: "600",
          color: "#2218a7ff",
          marginBottom: "8px",
        },
        tooltipContent: {
          fontSize: "0.95rem",
          lineHeight: "1.5",
          padding: "0px",
          marginBottom: "12px",
          color: "#4B5563",
        },
        footer: {
          marginTop: "12px",
          justifyContent: "flex-end",
        },
        buttonClose: {
          display: "none",
        },
        buttonNext: {
          backgroundColor: "#4F46E5",
          color: "#fff",
          borderRadius: "8px",
          padding: "8px 16px",
          fontWeight: "500",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          transition: "all 0.2s ease",
          ":hover": {
            backgroundColor: "#4338CA",
            transform: "translateY(-1px)",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          },
        },
        buttonBack: {
          color: "#2e21c0ff",
          marginRight: "16px",
          fontWeight: "500",
          borderRadius: "16px",
          padding: "10px 20px",
          background: "rgba(255, 255, 255, 0.6)",
          border: "1px solid rgba(147, 197, 253, 0.4)",
          transition: "all 0.3s ease",
          ":hover": {
            color: "#1D4ED8",
            background: "rgba(255, 255, 255, 0.8)",
            transform: "translateY(-2px)",
          },
        },
        buttonSkip: {
          color: "#475aeaff",
          marginRight: "auto",
          fontWeight: "500",
          textShadow: "1px 1px 2px rgba(255,255,255,0.8)",
          ":hover": {
            color: "#3B82F6",
            textDecoration: "underline",
          },
        },
        beacon: {
          inner: {
            backgroundColor: "#4F46E5",
          },
          outer: {
            backgroundColor: "rgba(79, 70, 229, 0.3)",
            border: "2px solid #4F46E5",
          },
        },
        spotlight: {
          borderRadius: "6px",
          boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.5)",
          margin: 2, // Added slight margin for better visibility
        },
      }}
      locale={{
        back: "← Back",
        close: "× Close",
        last: "☁ Finish",
        next: "Next →",
        skip: "Skip Tour",
      }}
    />
  );
};

export default TourGuide;
